export enum Role {
    SUPER_ADMIN = "SUPER_ADMIN",
    BACKOFFICE_ADMIN = "BACKOFFICE_ADMIN",
    ACCOUNTING_MANAGER = "ACCOUNTING_MANAGER",
    FINANCE_ADMIN = "FINANCE_ADMIN",
    SALES_ADMIN = "SALES_ADMIN",
    WAREHOUSE_ADMIN = "WAREHOUSE_ADMIN",
    FINANCE_STAFF = "FINANCE_STAFF",
    ORDER_MANAGER = "ORDER_MANAGER",
    WAREHOUSE_STAFF = "WAREHOUSE_STAFF",
    SHIPPING_STAFF = "SHIPPING_STAFF",
    SECRETARY = "SECRETARY",
    AUTH_ANY_ROLE = "AUTH_ANY_ROLE"
}